import { c as _c } from "react/compiler-runtime";
import { type ProgressRingProps } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/speed-key-messages/progress-ring/types';
import styles from '@/app/lcv/components/sections/spartan/engine/styles.module.css';
import { cn } from '@/app/utils/cn';
const OUTER_ARC_PATH = 'M15.03 110.52A66 66 0 1 1 126.21 108.58';
const INNER_ARC_PATH = 'M24.24 106.28A56 56 0 1 1 125.91 77.13';
const OUTER_ID = 'engine-speed-progress-ring-outer';
const GLOW_ID = 'engine-speed-progress-ring-glow';
const INNER_ID = 'engine-speed-progress-ring-inner';
export const ProgressRing = t0 => {
  const $ = _c(17);
  const {
    isFilled,
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== isFilled) {
    t1 = cn(styles.speedIndicator, styles.speedRing, {
      [styles.active]: isFilled
    }, className);
    $[0] = className;
    $[1] = isFilled;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <linearGradient id={OUTER_ID} x1="19.69" y1="23.25" x2="123.81" y2="112.06" gradientUnits="userSpaceOnUse"><stop offset="0.458" stopColor="#ED1C24" /><stop offset="1" stopColor="#FB5400" /></linearGradient>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs>{t2}<linearGradient id={INNER_ID} x1="24.94" y1="106.81" x2="127.75" y2="78.38" gradientUnits="userSpaceOnUse"><stop stopColor="#B36A6D" /><stop offset="1" stopColor="white" /></linearGradient></defs>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path d={OUTER_ARC_PATH} className={cn(styles.speedRingOuter, styles.speedRingTrack)} />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path d={INNER_ARC_PATH} className={cn(styles.speedRingInner, styles.speedRingTrack)} />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d={OUTER_ARC_PATH} pathLength={100} stroke={`url(#${OUTER_ID})`} className={cn(styles.speedRingOuter, styles.speedRingProgress)} />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <svg aria-hidden={true} viewBox="0 0 140 140" fill="none" className={styles.speedIndicatorArt}>{t3}{t4}{t5}{t6}<path d={INNER_ARC_PATH} pathLength={100} stroke={`url(#${INNER_ID})`} className={cn(styles.speedRingInner, styles.speedRingProgress)} /></svg>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn(styles.speedIndicatorArt, styles.speedRingGlow);
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <defs><linearGradient id={GLOW_ID} x1="19.69" y1="23.25" x2="123.81" y2="112.06" gradientUnits="userSpaceOnUse"><stop stopColor="#ED1C24" stopOpacity="0" /><stop offset="0.427" stopColor="#F63A11" /><stop offset="0.812" stopColor="#FF5500" /><stop offset="1" stopColor="#FF8651" /></linearGradient></defs>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <svg aria-hidden={true} viewBox="0 0 140 140" fill="none" className={t8}>{t9}<path d={OUTER_ARC_PATH} pathLength={100} stroke={`url(#${GLOW_ID})`} className={cn(styles.speedRingOuter, styles.speedRingProgress)} /></svg>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== children) {
    t11 = <div className={styles.speedIndicatorContent}>{children}</div>;
    $[12] = children;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t1 || $[15] !== t11) {
    t12 = <div className={t1}>{t7}{t10}{t11}</div>;
    $[14] = t1;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  return t12;
};